<script>
  /**
   * @type {number} width of the progress bar
   */
  export let width = 0

  /**
   * @type {string} content to be shown along with the progress
   */
  export let content = "Uploading File"

  /**
   * @type {Boolean} - this value reactively changed in terms of KB when file is uploading to backend
   */
  // export let progressLoaded = 0

  /**
   * @type {Boolean} - this value denotes the file size terms of KB
   */
  // export let progressTotal = 0

  /**
   * @type {String} - width percentage text size
   */
  export let percentTextSize = "lg:text-3xl text-2xl"

  /**
   * @type {String} - loading text size
   */
  export let contentSize = "text-lg"

  /**
   * @type {String} - whether to show staus text
   */
  export let status = false

  /**
   * @type {String} - file size text size
   */
  // export let kbSizeText = "text-base"
</script>

<div class="relative flex w-full flex-col items-center justify-center gap-12 text-base font-bold text-[#ff6a00] mobile:text-lg">
  <button on:click class="absolute top-3 right-4 text-red-500 hover:text-red-600">
    <i class="fa-solid fa-circle-xmark" />
  </button>
  <div class="flex w-full flex-col items-center gap-3 mobile:gap-6">
    <div class="flex w-full items-center justify-center">
      <div class="font-bold dark:text-white {percentTextSize}">{width.toFixed(2) || 0} %</div>
      <!-- <div class="{kbSizeText} font-normal text-white">{`${progressLoaded / 1000} kb / ${progressTotal / 1000} kb`}</div> -->
    </div>
    <div class="progress w-full bg-[#dfdfdf]">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: {width}%" />
    </div>
    <h1 class="{contentSize} font-medium tracking-widest text-[#ff6a00]">{content} ...</h1>
    {#if status}
      <h1 class="text-center text-sm font-medium tracking-widest text-red-500">Your request is being processed. Please do not refresh the page...</h1>
    {/if}
  </div>
</div>

<style lang="postcss">
  .progress {
    display: -ms-flexbox;
    display: flex;
    height: 1.25rem;
    overflow: hidden;
    font-size: 0.75rem;
    /* background-color: #dfdfdf; */
    border-radius: 0.25rem;
  }

  .progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 1rem 1rem;
  }

  .progress-bar-animated {
    -webkit-animation: progress-bar-stripes 1s linear infinite;
    animation: progress-bar-stripes 1s linear infinite;
  }

  @keyframes progress-bar-stripes {
    0% {
      background-position: 1rem 0;
    }
    100% {
      background-position: 0 0;
    }
  }

  .progress-bar {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-pack: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    background-color: #ff6a00;
    transition: width 0.6s ease;
  }
</style>
